import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { useI18n } from "../i18n";
import { useAuth } from "../AuthContext";

const FlagToggle = () => {
  const { lang, setLang } = useI18n();
  return (
    <button
      data-testid="lang-toggle"
      onClick={() => setLang(lang === "en" ? "ro" : "en")}
      className="font-mono text-xs uppercase tracking-widest border border-[#27272A] px-3 py-2 text-white hover:border-white/40"
      style={{ background: "transparent" }}
      aria-label="Toggle language"
    >
      {lang === "en" ? "🇬🇧 EN" : "🇷🇴 RO"}
    </button>
  );
};

const Header = () => {
  const { t } = useI18n();
  const { accessCode, signOut } = useAuth();
  const navigate = useNavigate();

  return (
    <header
      className="sticky top-0 z-50 backdrop-blur-xl border-b"
      style={{ background: "rgba(10,10,10,0.85)", borderColor: "#27272A" }}
    >
      <div className="max-w-7xl mx-auto px-4 md:px-8 py-4 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-3" data-testid="header-logo">
          <img
            src="/logo.svg"
            alt="Sports Nutrition Engine"
            width="36"
            height="36"
            style={{ display: "block" }}
          />
          <div className="flex items-center gap-2">
            <div className="font-heading text-xl md:text-2xl tracking-tight">
              SPORTS NUTRITION <span style={{ color: "#FF3B30" }}>ENGINE</span>
            </div>
            <span
              className="font-mono text-[9px] tracking-widest px-1.5 py-0.5 hidden md:inline-block"
              style={{ background: "#FF3B30", color: "white" }}
              data-testid="header-pilot-badge"
            >
              PILOT
            </span>
          </div>
        </Link>
        <div className="flex items-center gap-3">
          {!accessCode ? (
            <>
              <Link to="/pricing" data-testid="header-pricing" className="hidden md:inline font-mono text-xs uppercase tracking-widest text-white/70 hover:text-white">
                {t.nav.pricing}
              </Link>
              <Link to="/login" data-testid="header-signin" className="font-mono text-xs uppercase tracking-widest text-white px-3 py-2 border border-[#27272A] hover:border-white/40">
                {t.nav.signin}
              </Link>
            </>
          ) : (
            <button
              data-testid="header-logout"
              onClick={() => { signOut(); navigate("/"); }}
              className="font-mono text-xs uppercase tracking-widest text-white px-3 py-2 border border-[#27272A] hover:border-white/40"
              style={{ background: "transparent" }}
            >
              {t.nav.logout}
            </button>
          )}
          <FlagToggle />
        </div>
      </div>
    </header>
  );
};

export default Header;
